import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';

const BacktestStartAnimation = ({ isVisible, onAnimationComplete }) => {
  useEffect(() => {
    if (isVisible) {
      // Auto-hide after animation duration (3 seconds)
      const timer = setTimeout(() => {
        if (onAnimationComplete) {
          onAnimationComplete();
        }
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, onAnimationComplete]);

  if (!isVisible) return null;

  return (
    <div className="backtest-start-animation">
      <div className="animation-content">
        <Spinner animation="border" role="status" />
        <h3>Starting Backtest</h3>
        <p>Initializing strategy parameters...</p>
      </div>
    </div>
  );
};

export default BacktestStartAnimation;